<template>
    <div class="condition-content">
        <div
            ref="selectTrigger"
            class="select-trigger"
            :class="{
                'trigger-invalid': !valid,
                'select-trigger--empty': timeList.length === 0
            }"
        >
            <span>{{ content }}</span>
            <v-icon name="arrow_dropdown" />
        </div>
        <time-select-popper
            ref="timeSelectPopper"
            :multiple="true"
            :value="timeList"
            placement="bottom-start"
            @change="onChange"
        />
    </div>
</template>

<script>
import TimeSelectPopper from '@/components/time-select-popper-new';

export default {
  name: 'TimeMaterial',

  components: {
    TimeSelectPopper,
  },

  props: {
    valid: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: '请选择时间条件',
    },
  },

  data() {
    const currentValue = this.value || {};
    const selectorValue = currentValue.operand;
    const timeList = currentValue.value || [];
    return {
      selectorType: 'LOGIC',
      selectorValue,
      timeList,
    };
  },

  computed: {
    content() {
      let result = '';
      if (this.timeList.length) {
        this.timeList.forEach((item, index) => {
          result += item.name;
          if (index !== this.timeList.length - 1) {
            result += ',';
          }
        });
      } else {
        result = this.placeholder;
      }
      return result;
    },
  },

  watch: {
    value(newValue) {
      const currentValue = newValue || {};
      this.selectorValue = currentValue.operand;
      this.timeList = currentValue.value || [];
    },
  },

  mounted() {
    this.$refs.timeSelectPopper.bindTrigger(this.$refs.selectTrigger);
  },

  methods: {
    onChange(value) {
      this.valid = true;
      this.$emit('change', {
        operand: this.selectorValue,
        value,
      });
    },
  },
};
</script>
